module.exports = __webpack_public_path__ + "img/Cancer.56ecac4b.svg";